import { render, staticRenderFns } from "./InsuranceAdd.vue?vue&type=template&id=5ba67938&scoped=true&"
import script from "./InsuranceAdd.vue?vue&type=script&lang=js&"
export * from "./InsuranceAdd.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceAdd.vue?vue&type=style&index=0&id=5ba67938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba67938",
  null
  
)

export default component.exports